import { render, staticRenderFns } from "./RollbackDisk.vue?vue&type=template&id=6070de42"
import script from "./RollbackDisk.vue?vue&type=script&lang=js"
export * from "./RollbackDisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports